const DOMAIN_REGEXP = /^((?!-)[А-Яа-яA-Za-z0-9-]{1,63}(?<!-)\.)+[А-Яа-яA-Za-z]{2,16}$/;

export default DOMAIN_REGEXP;